import { protocolCountries } from '@/api/site'

export default {
  'entityName': 'drug',
  'pagination': {
    'rowsPerPage': 5,
    'page': 1,
    'sortBy': 'id',
    'descending': true
  },
  'fields': [
    {
      'value': 'name',
      'text': 'Name',
      'type': 'text',
      slim: true,
      'table': {
        'sortable': true
      },
      'validators': [
        'required'
      ]
    },
    {
      'value': 'packaging',
      'text': 'Packaging',
      'type': 'list',
      render: item => item.packaging !== 'Labels' ? item.packaging : `Labels (${item.labels?.join(', ')})`,
      'table': {
        'sortable': true
      },
      slim: true,
      'list': [
        'Blister',
        'Bottle',
        "Bottle CPS",
        "Vials",
        "Labels"
      ],
      'validators': [
        'required'
      ]
    },    
    {
      value: 'labels',
      text: 'Labels applied to',
      type: 'combobox',
      manual: true,
      multiple: true,
      deps: ['packaging'],
      visible: item => item.packaging === 'Labels',
      small: true,
      'validators': [
        'required'
      ]
    },
    {
      'value': 'dose',
      'text': 'Dose',
      'type': 'number',
      mini: true,
      deps: ['packaging'],
      visible: item => item.packaging !== 'Labels',
      render: item => `${item.dose}${item.measure_unit} `,
      'table': {
        'sortable': true
      },
      'validators': [
        'required'
      ]
    },
    {
      value: 'measure_unit',
      text: 'Unit',
      type: 'text',
      mini: true,
      visible: item => item.packaging !== 'Labels',
      deps: ['packaging'],
      validators: [
        // e' required solo se non e' labels
        (field, value, item) => {
          if (item.packaging !== 'Labels') {
            return !!value || 'Unit is required'
          }
          return true
        }
      ]
    },
    {
      'value': 'n_pieces',
      'text': 'N. items',
      'type': 'number',
      mini: true,
      'table': {
        'sortable': true
      },
      'validators': [
        'required',
        'number'
      ]
    },
    {
      mini: true,
      'value': 'deposit',
      'text': 'Own storage',
      'type': 'check',
      default: () => 0,
      readonly: item => !!item.always_available,
      deps: ['always_available'],
      visible: (item, state) => state.user.role !== 'EMN Estimates'
    },
    {
      slim: true,
      value: 'always_available',
      table: true,
      text: 'Always available',
      type: 'check',
      visible: (item, state) => state.user.role !== 'EMN Estimates'
    },
    {
      slim: true,
      value: 'no_more_available',
      table: true,
      text: 'No more available',
      type: 'check'
    },
    {
      slim: true,
      value: 'serials_available',
      table: true,
      text: 'Serials available',
      deps: ['packaging'],
      default: item => item.packaging === 'Labels' ? 0 : item.serials_available,
      readonly: item => item.packaging === 'Labels',
      type: 'check',
      visible: (item, state) => state.user.role !== 'EMN Estimates'
    },
    {
      'value': 'multiplier',
      'text': 'Multiplier',
      mini: true,
      'type': 'number',
      'validators': [
        'number'
      ],
      visible: (item, state) => state.user.role !== 'EMN Estimates'
    },
    {
      'value': 'min_stock',
      mini: true,
      'text': 'Min stock',
      'type': 'number',
      visible: (item, state) => state.user.role !== 'EMN Estimates',
      readonly: item => !!item.always_available,
      'validators': [
        // e' required solo se non e' always available
        (field, value, item) => {
          if (!item.always_available) {
            return value !== '' || 'Min stock is required'
          }
          return true
        },
        'number'
      ]
    },
    {
      'value': 'provider_id',
      'text': 'Provider',
      'type': 'autocomplete',
      'title': 'name',
      'subtitle': 'city',
      table: true,
      small: true,
      validators: ['required']
    },
    {
      'value': 'reference_provider_id',
      'text': 'Provider reference',
      'type': 'autocomplete',
      id: 'id',
      title: item => `${item.name} ${item.surname}`,
      multiple: true,
      subtitle: 'email',
      default: () => undefined,
      deps: ['provider_id', 'always_available' , 'deposit'],
      filter: drug => drug.provider_id && ({ provider_id: drug.provider_id }),
      readonly: item => !!item.storage_id || !item.provider_id,
      visible: (item, state) => state.user.role !== 'EMN Estimates',
      small: true
    },
    {
      value: 'countries',
      text: 'Countries',
      reference: 'drug',
      list:  (entity, search, item) => protocolCountries(item.protocol_id),
      id: 'country_code',
      title: 'country_code',
      // filter: drug => ({ protocol_id: drug.protocol_id }),
      table: true,
      render: item => item.countries && item.countries.length ? item.countries.join(', ') : 'All',
      type: 'autocomplete',
      // manual: true,
      multiple: true,
      small: true,
      // validators: [
      //   (field, countries) => {
      //     if (!countries) return true
      //     const f = countries.find(c => c.length !== 2)
      //     if (f) {
      //       return `Country should be 2 chars (${f})`
      //     }
      //     return true
      //   }
      // ]
    },
    {
      'value': 'storage_id',
      'text': 'Storage',
      'type': 'autocomplete',
      'title': 'name',
      'subtitle': 'city',
      deps: ['deposit', 'always_available'],
      default: () => undefined,
      readonly: item => !!item.deposit || !!item.always_available,
      validators: [
        // e' required solo se non e' always available e non e' own storage
        (field, value, item) => {
          if (!item.always_available && !item.deposit) {
            return !!value || 'Storage is required if not always available and not own storage'
          }
          return true
        },
      ],
      visible: (item, state) => state.user.role !== 'EMN Estimates'
    },
    {
      'value': 'reference_storage_id',
      'text': 'Storage reference',
      'type': 'autocomplete',
      id: 'id',
      title: item => `${item.name} ${item.surname}`, 
      multiple: true,
      subtitle: 'email',
      deps: ['storage_id', 'deposit'],
      default: () => undefined,
      filter: drug => drug.storage_id && ({ storage_id: drug.storage_id }),
      readonly: item => !!item.deposit || !item.storage_id,
      validators: [
        // e' required solo se storage_id
        (field, value, item) => {
          if (item.storage_id) {
            return !!value || 'Storage reference is required'
          }
          return true
        },
      ],
      visible: (item, state) => state.user.role !== 'EMN Estimates'
    },
    {
      'value': 'disposal_id',
      'text': 'Disposal',
      'type': 'autocomplete',
      'title': 'name',
      'subtitle': 'name',
      deps: ['packaging'],
      default: item => item.packaging === 'Labels' ? null : item.disposal_id,
      readonly: item => item.packaging === 'Labels',
      validators: ['required'],
      visible: (item, state) => state.user.role !== 'EMN Estimates'
    },
    {
      'value': 'reference_disposal_id',
      'text': 'Disposal reference',
      'type': 'autocomplete',
      id: 'id',
      title: item => `${item.name} ${item.surname}`,
      multiple: true,
      'subtitle': 'email',
      deps: ['disposal_id'],
      readonly: item => !item.disposal_id,
      'filter': drug => ({ disposal_id: drug.disposal_id }),
      validators: ['required'],
      visible: (item, state) => state.user.role !== 'EMN Estimates'
    },
    {
      value: 'request_mode',
      type: 'textarea',
      text: 'Note',
      full: true,
      visible: (item, state) => state.user.role !== 'EMN Estimates'
    },
  ],
  'actions': [
    'upsert',
    'audit',
    { "value": "clone", "text": "Clone", "color": "primary", "icon": "mdi-content-copy" },
    'remove'
  ]
}
